module.exports = __webpack_public_path__ + "img/wibo_bed_2.6a07b470.png";